module.exports = __webpack_public_path__ + "img/Daumen.a87d75ba.svg";